import { GameEvent } from './../core/GameAbstract';
import { GlobulesAGogo } from './GlobulesAGogo';
import { Assets } from '../core/Assets';
import AbstractDispatcher from 'frontools/abstract/AbstractDispatcher';
import { autobind } from 'frontools/decorators/Autobind';
import EventType from 'frontools/events/EventType';
import NumberUtils from 'frontools/utils/NumberUtils';  

export class BloodCell extends AbstractDispatcher {

    public static CLICKED          : string         = "BLOOD_CELL_CLICKED";
    public static TRIGGER_NEW_ONE  : string         = "NEW_ONE";
    public static PNG_OFFSET       : number         = 33; // transparent offset in sprite between edge and blood cell
    public static NEW_ONE_OFFSET   : number         = 0; // transparent offset in sprite between edge and blood cell
    public static SCALE_FACTOR_X   : number         = 0.55;
    public static SCALE_FACTOR_Y   : number         = 0.65;

    private _game           :       GlobulesAGogo   = GlobulesAGogo.instance;
    private _clicked        :       boolean         = false;
    private _container      :       PIXI.Container;
    private _lastY          :       number;
    private _scaledOffset   :       number          = 33;
    private _scale          :       number;       
    private _speedDelay     :       number          = 10;
    private _sprite         :       PIXI.extras.AnimatedSprite;
    private _tween          :       TweenMax;
    
    

    constructor(column: number) {
        super();
        this._sprite =  Assets.getSpriteFromJson('globules') as PIXI.extras.AnimatedSprite;
        this._sprite.loop = false;
        this._sprite.scale.x = BloodCell.SCALE_FACTOR_X * this._game.resolution;
        this._sprite.scale.y = BloodCell.SCALE_FACTOR_Y * this._game.resolution;
        this._scaledOffset = BloodCell.PNG_OFFSET * this._sprite.scale.x;
        
        this._sprite.x = this._getAbsciss(column);
        this._sprite.y = -this._sprite.height;

        this._lastY = this._sprite.y;
        this._sprite.pivot.x =  this._sprite.width / 2;
        this._sprite.pivot.y =  this._sprite.height / 2;
       
        this._tween = TweenMax.to(this._sprite, this._speedDelay, {y: this._game.screenHeight + this._sprite.height,  ease: Linear.easeNone,
            onUpdate: this._onUpdate,
            onComplete: this._delete
        });

        this._container = new PIXI.Container();
        this._container.addChild(this._sprite);
        this._container.interactive = true;
        this._container.buttonMode = true;
        this._container.on(GameEvent.CLICK, this._onClick, this);
        this._container.on(GameEvent.TAP, this._onClick, this);
    }

    /**
     * Returns absciss coordinate in BloodCellContainer.
     * 
     * @param column number. Should an integer between 1 and 4
     */
    private _getAbsciss(column: number) {
        // My eyes are bleeding. @todo find a better way to calculate absciss.   
        let absciss = 0,
            padding = this._game.resolution == 1 ? 7 : 33;
        
        //absciss = padding + (column - 1) * (this._sprite.width - (this._scaledOffset / this._game.resolution));
        absciss = padding + (column - 1) * ((this._sprite.width * .93) - (this._scaledOffset / this._game.resolution));

        return absciss;
    }

    private _onClick(e) {
        e.stopPropagation();
        if (!this._clicked) {
            this._clicked = true;
            this._sprite.play();
            this.dispatch({ type: BloodCell.CLICKED, game: this._game }); 
        }
    }

    @autobind
    private _onUpdate(e) {
        if (this._lastY < BloodCell.NEW_ONE_OFFSET && this._sprite.y >= BloodCell.NEW_ONE_OFFSET) {
            this.dispatch({ type: BloodCell.TRIGGER_NEW_ONE, bloodCell: this}); 
        }
        this._lastY = this._sprite.y;
        this._tween.timeScale(this._game.timeScale);
    }

    @autobind
    private _delete() {
        this._container.removeChild(this._sprite); 
        this._game.bloodCellsContainer.removeChild(this._container); 
    }

    public get sprite() : PIXI.extras.AnimatedSprite {
        return this._sprite;    
    }

    public get container() : PIXI.Container {
        return this._container;    
    }

}